import { createSvgIcon } from '@mui/material';
import React from 'react';

export const Attach = createSvgIcon(
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
		fill="currentColor"
		version="1.1"
		style={{
			shapeRendering: 'geometricPrecision',
			textRendering: 'geometricPrecision',
			imageRendering: 'optimizeQuality',
			fillRule: 'evenodd',
			clipRule: 'evenodd',
		}}
		viewBox="0 0 328000 328000"
	>
		{/* <defs>
			<style>{`.fil0 { fill: currentColor; }`}</style>
		</defs> */}
		<g id="Camada_x0020_1">
			<metadata id="CorelCorpID_0Corel-Layer" />
			<path fill="currentColor" class="fil0" d="M245000 135000c29000,28000 29000,75000 1000,104000l0 0c-29000,29000 -76000,29000 -105000,0 -29000,-29000 -29000,-75000 0,-104000 29000,-29000 76000,-29000 104000,0zm-98000 -135000l-42000 0 -95000 0c-5000,0 -10000,5000 -10000,10000l0 99000 0 208000c0,6000 5000,11000 10000,11000l232000 0c6000,0 11000,-5000 11000,-11000l0 -19000 -4000 -3000c-46000,24000 -103000,16000 -141000,-22000 -3000,-3000 -5000,-6000 -8000,-9000l-47000 0c-6000,0 -11000,-4000 -11000,-10000 0,-6000 5000,-11000 11000,-11000l33000 0c-3000,-6000 -6000,-14000 -9000,-21000l-24000 0c-6000,0 -11000,-5000 -11000,-10000 0,-6000 5000,-11000 11000,-11000l20000 0c-1000,-7000 -1000,-14000 0,-21000l-20000 0c-6000,0 -11000,-5000 -11000,-11000 0,-6000 5000,-10000 11000,-10000l23000 0c5000,-21000 15000,-41000 32000,-58000 26000,-26000 59000,-38000 96000,-35000 17000,1000 32000,6000 49000,15000l0 -71000c0,-5000 -5000,-10000 -11000,-10000l-95000 0zm36000 92000c-21000,3000 -41000,12000 -57000,28000 -37000,37000 -37000,97000 0,134000 35000,35000 89000,37000 127000,7000l60000 60000 15000 -15000 -60000 -60000c29000,-37000 27000,-92000 -8000,-126000 -17000,-17000 -38000,-27000 -60000,-28000 -5000,0 -12000,0 -17000,0z" />

		</g>
	</svg>,
	'Attach'
);
